import React, { useState } from "react";
import "./SupportAnchorBanner.css";

type Props = {
  sectionId?: string;
};

export function SupportAnchorBanner({ sectionId = "support-section" }: Props) {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="csup-banner" id="supportBanner">
      <span className="csup-banner-catch">知っておくと差がつく使い方</span>

      <div className="csup-banner-divider" />

      <div className="csup-banner-tabs">
        <span className="csup-banner-tab csup-banner-tab-kotsu">
          <svg viewBox="0 0 16 16" fill="#085041">
            <path d="M8 1.5a5 5 0 015 5c0 1.8-1 3.4-2.4 4.3L10 12H6l-.6-1.2A5 5 0 018 1.5z" />
          </svg>
          運用のコツ
        </span>

        <span className="csup-banner-tab csup-banner-tab-faq">
          <svg viewBox="0 0 16 16" fill="#0c447c">
            <path d="M14 2H2a1 1 0 00-1 1v8a1 1 0 001 1h2v2.5l3-2.5h7a1 1 0 001-1V3a1 1 0 00-1-1z" />
          </svg>
          よくある質問
        </span>

        <span className="csup-banner-tab csup-banner-tab-shikumi">
          <svg viewBox="0 0 16 16" fill="#3c3489">
            <path d="M8 1a7 7 0 100 14A7 7 0 008 1zm0 11.5a1 1 0 110-2 1 1 0 010 2zm.7-4.2c-.4.3-.7.6-.7 1v.2H6.5v-.2c0-.9.5-1.6 1.1-2C8 6.9 8.3 6.6 8.3 6c0-.6-.5-1-1.2-1-.6 0-1.1.4-1.2.9H4.3C4.5 4.8 5.6 4 7 4c1.6 0 2.7 1 2.7 2.3 0 .9-.5 1.6-1 2z" />
          </svg>
          仕組みを知る
        </span>
      </div>

      <a className="csup-banner-link" href={`#${sectionId}`}>
        確認する
        <svg viewBox="0 0 12 12" fill="none" stroke="#185fa5" strokeWidth="1.5">
          <path d="M6 2v8M2 7l4 4 4-4" />
        </svg>
      </a>

      <button type="button" className="csup-banner-close" onClick={() => setVisible(false)} title="閉じる" aria-label="閉じる">
        ✕
      </button>
    </div>
  );
}
